export const CLEAR_LOCATIONS = 'clear-locations';
const clearLocations = () => ({ type: CLEAR_LOCATIONS });
export default clearLocations;
